const mailRoutes = [
  {
    title: 'Projects',
    fullTitle: 'Projects',
    icon: 'apps',
    titleIcon: true,
    path: '/mail/projects',
    permission: 'mail.projects.view',
  },
  {
    title: 'Categories',
    fullTitle: 'Email Categories',
    icon: 'category',
    titleIcon: true,
    path: '/mail/categories',
    permission: 'mail.categories.view',
  },
  {
    title: 'Email Types',
    fullTitle: 'Email Types',
    icon: 'format_list_bulleted',
    titleIcon: true,
    path: '/mail/types',
  },
  {
    title: 'Templates',
    fullTitle: 'Email Templates',
    icon: 'subject',
    titleIcon: true,
    path: '/mail/email-templates',
    permission: 'mail.templates.view',
  },
  {
    title: 'Templates Report',
    fullTitle: 'Email Templates Report',
    icon: 'flag',
    titleIcon: true,
    path: '/mail/template-report',
    permission: 'mail.emails.view',
  },
  {
    title: 'Send Emails',
    fullTitle: 'Send Emails',
    icon: 'send',
    titleIcon: true,
    path: '/mail/send-emails',
    permission: 'mail.emails.view',
    default: true,
  },
  {
    title: 'History',
    fullTitle: 'View email History',
    icon: 'history',
    titleIcon: true,
    path: '/mail/history',
    permission: 'mail.history.view',
  },
  {
    title: 'Authorize Gmail',
    fullTitle: 'Authorize with Gmail',
    icon: 'mail_outline',
    titleIcon: true,
    path: '/mail/gmail',
    permission: 'mail.authorize.view',
  },
  {
    title: 'A/B Test',
    fullTitle: 'Template A/B Test',
    icon: 'science',
    titleIcon: true,
    path: '/mail/template-ab-test',
    permission: 'mail.emails.view',
  },
  {
    title: 'Throttle Exemptions',
    fullTitle: 'Throttle Exemption List',
    icon: 'lock_open',
    titleIcon: true,
    path: '/mail/throttle-exemptions',
    permission: 'mail.emails.view',
  },
  {
    title: 'Utilities',
    fullTitle: 'Email Utilities',
    icon: 'home_repair_service',
    titleIcon: true,
    path: '/mail/utilities',
  },
  {
    title: 'Spam Words',
    fullTitle: 'Spam Words',
    icon: 'block',
    titleIcon: true,
    path: '/mail/spam-words',
  },
  {
    title: 'Enoch Config',
    fullTitle: 'Enoch Configuration',
    icon: 'psychology',
    titleIcon: true,
    path: '/mail/enoch-config',
  },
];

export default mailRoutes;
